import React from 'react';
import { Stack, TextField } from '@mui/material';
import InputLabel from '../InputLabel';

const EnquiryInfoAddMessage = ({
  label = 'ADD A MESSAGE',
  register,
  placeholder = 'Type your message here',
}) => {
  return (
    <Stack direction='column' spacing={2}>
      <InputLabel name='enquiry-info-add-message' label={label} />
      <TextField
        multiline
        sx={{
          '& .MuiInputBase-root': {
            background: '#fff',
            padding: '8px 10px',
            fontSize: 12,
            lineHeight: 1.33,
            '&:placeholder': {
              color: '#969696',
            },
          },
          '& .MuiOutlinedInput-input': {
            padding: 0,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            top: -8,
          },
        }}
        fullWidth
        rows={5}
        variant='outlined'
        id='enquiry-info-add-message'
        name='message'
        {...register('message')}
        placeholder={placeholder}
      />
    </Stack>
  );
};

export default EnquiryInfoAddMessage;
